import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EmployeeResponse } from 'src/app/models/employee.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HumanResourcesService } from 'src/app/services/human-resources.service';

@Component({
  selector: 'app-modal-hiring-documents',
  templateUrl: './modal-hiring-documents.component.html',
  styleUrls: ['./modal-hiring-documents.component.scss', '../modal-admin-area/modal-admin-area.component.scss']
})
export class ModalHiringDocumentsComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();
  @Input() newEmployee: EmployeeResponse = new EmployeeResponse();
  uploadingImage = false;
  loadingImage = false;
  uploadingID = false;
  uploadingPolicy = false;
  uploadingPenal = false;
  uploadingWorkContract = false;
  uploadingPsycometricTest = false;

  constructor(
    private toastService: ToastrService,
    private rrhhService: HumanResourcesService
  ) {

  }

  ngOnInit(): void {

  }

  closeUploadImage(dataIMG: string) {
    this.uploadingImage = false;
    if (dataIMG != '') {
      this.loadingImage = true;
      this.rrhhService.changeImageEmployee(this.newEmployee.id, dataIMG).subscribe({
        next: (response: ResponseObject) => {
          this.newEmployee.foto = response.data;
          this.loadingImage = false;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
          this.loadingImage = false;
        }
      })
    }
  }

  uploadID() {
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (e: any) => {
      var file = e.target.files[0];
      if (file) {
        this.uploadingID = true;
        this.rrhhService.addID(this.newEmployee.id, file).subscribe({
          next: (response: ResponseObject) => {
            this.newEmployee.documento = response.data;
            this.uploadingID = false;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
            this.uploadingID = false;
          }
        });
      } else {
        this.uploadingID = false;
      }
    }
    input.click();
  }

  uploadPolicy(){
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,application/pdf';
    input.onchange = (e: any) => {
      var file = e.target.files[0];
      if (file) {
        this.uploadingPolicy = true;
        this.rrhhService.addPolicy(this.newEmployee.id, file).subscribe({
          next: (response: ResponseObject) => {
            this.newEmployee.policiacos = response.data;
            this.uploadingPolicy = false;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
            this.uploadingPolicy = false;
          }
        });
      } else {
        this.uploadingPolicy = false;
      }
    }
    input.click();
  }

  uploadWorkContract(){
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,application/pdf';
    input.onchange = (e: any) => {
      var file = e.target.files[0];
      if (file) {
        this.uploadingWorkContract = true;
        this.rrhhService.addWorkContract(this.newEmployee.id, file).subscribe({
          next: (response: ResponseObject) => {
            this.newEmployee.workContract = response.data;
            this.uploadingWorkContract = false;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
            this.uploadingWorkContract = false;
          }
        });
      } else {
        this.uploadingWorkContract = false;
      }
    }
    input.click();
  }

  uploadPsicommetricTest(){
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,application/pdf';
    input.onchange = (e: any) => {
      var file = e.target.files[0];
      if (file) {
        this.uploadingPsycometricTest = true;
        this.rrhhService.addPsicommetricTest(this.newEmployee.id, file).subscribe({
          next: (response: ResponseObject) => {
            this.newEmployee.psychometricTests = response.data;
            this.uploadingPsycometricTest = false;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
            this.uploadingPsycometricTest = false;
          }
        });
      } else {
        this.uploadingPsycometricTest = false;
      }
    }
    input.click();
  }

  uploadPenal(){
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,application/pdf';
    input.onchange = (e: any) => {
      var file = e.target.files[0];
      if (file) {
        this.uploadingPenal = true;
        this.rrhhService.addPenal(this.newEmployee.id, file).subscribe({
          next: (response: ResponseObject) => {
            this.newEmployee.penales = response.data;
            this.uploadingPenal = false;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
            this.uploadingPenal = false;
          }
        });
      } else {
        this.uploadingPenal = false;
      }
    }
    input.click();
  }
}
